import { useEffect, useState } from 'react';
import {
    Alert, Button, FormControl, FormHelperText, FormLabel,
    Modal, ModalDialog, Option, Select, Stack, Textarea, Typography,
} from '@mui/joy';

import { REJECTION_REASONS } from './adsConstants';


/**
 * Отклонение или возврат на доработку.
 *
 * Причина обязательна и выбирается из списка: она уходит партнёру
 * в кабинет и в лог модерации. Свободное «не подходит» гарантирует
 * повторный заход с тем же объявлением.
 */
export default function AdRejectModal({
    open, onClose, onSubmit, title, subject, mode = 'reject', saving,
}) {
    const [reason, setReason] = useState('');
    const [comment, setComment] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        if (open) { setReason(''); setComment(''); setError(null); }
    }, [open]);

    const submit = () => {
        if (!reason) { setError('Выберите причину — она будет показана рекламодателю'); return; }
        if (reason === 'other' && !comment.trim()) {
            setError('Для причины «Другое» комментарий обязателен');
            return;
        }
        onSubmit({ reason, comment: comment.trim() });
    };

    return (
        <Modal open={open} onClose={saving ? undefined : onClose}>
            <ModalDialog sx={{ width: { xs: '94vw', sm: 480 } }}>
                <Typography level="title-lg">
                    {title || (mode === 'changes' ? 'Вернуть на доработку' : 'Отклонить')}
                </Typography>
                {subject && (
                    <Typography level="body-sm" color="neutral" sx={{ mb: 1 }}>
                        {subject}
                    </Typography>
                )}

                {error && <Alert color="danger" sx={{ mb: 1.5 }}>{error}</Alert>}

                <Stack spacing={1.5}>
                    <FormControl>
                        <FormLabel>Причина</FormLabel>
                        <Select
                            value={reason}
                            onChange={(_, v) => setReason(v || '')}
                            placeholder="Выберите причину"
                        >
                            {REJECTION_REASONS.map((item) => (
                                <Option key={item.value} value={item.value}>{item.label}</Option>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl>
                        <FormLabel>Комментарий рекламодателю</FormLabel>
                        <Textarea
                            minRows={3}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Что именно нужно исправить"
                        />
                        <FormHelperText>
                            Текст увидит партнёр в своём кабинете. Чем конкретнее,
                            тем меньше повторных заходов на модерацию.
                        </FormHelperText>
                    </FormControl>

                    <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        <Button variant="outlined" color="neutral" fullWidth onClick={onClose} disabled={saving}>
                            Отмена
                        </Button>
                        <Button
                            color={mode === 'changes' ? 'warning' : 'danger'}
                            fullWidth
                            loading={saving}
                            onClick={submit}
                        >
                            {mode === 'changes' ? 'Вернуть на доработку' : 'Отклонить'}
                        </Button>
                    </Stack>
                </Stack>
            </ModalDialog>
        </Modal>
    );
}